import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

export const Faq = ({ items, testidPrefix = "faq" }) => (
  <Accordion type="single" collapsible className="w-full" data-testid={`${testidPrefix}-accordion`}>
    {items.map((f, i) => (
      <AccordionItem key={i} value={`item-${i}`} className="border-white/10">
        <AccordionTrigger
          data-testid={`${testidPrefix}-question-${i}`}
          className="text-left text-white hover:text-[#FF9100] hover:no-underline text-base font-medium"
        >
          {f.q}
        </AccordionTrigger>
        <AccordionContent data-testid={`${testidPrefix}-answer-${i}`} className="text-gray-400 leading-relaxed">
          {f.a}
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
